/**
 * The two scanner routes (2026-09-26). `/v2/scanner` is the grid, capped on the
 * server at the caller's plan rows (50 to 150). `/v2/scanner/universe` runs the
 * same query for whole-market reads (the heatmap, the planner's run closes),
 * capped at SCANNER_UNIVERSE_MAX_ROWS for every plan.
 */
export const SCANNER_UNIVERSE_MAX_ROWS = 2000

export function scannerUrl({
  historical_date,
  historical_time,
  universe,
}: {
  historical_date?: string
  /** HH:MM New York time. Only honoured next to a historical_date (minute snapshot). */
  historical_time?: string
  universe?: boolean
}): string {
  const path = universe ? '/v2/scanner/universe' : '/v2/scanner'
  if (!historical_date) return path
  const time = historical_time ? `&historical_time=${historical_time}` : ''
  return `${path}?historical_date=${historical_date}${time}`
}
